import { State } from '@/models/main';

export const state: State = {
  jobData: {
    all: [],
    cancelled: [],
    completed: [],
    in_progress: [],
    unallocated: [],
  },
  jobBfixData: {
    all: [],
    cancelled: [],
    completed: [],
    in_progress: [],
    unallocated: [],
  },
  availableStates: ['WA', 'NT', 'SA', 'QLD', 'NSW', 'TAS', 'VIC', 'ACT', 'NZ'].sort(),
  alertTimeout: 50000,
  labels: ['Booked', 'Allocated', 'Stop1(departed)', 'Stop2(arrived)', 'Stop2(POD)', 'Completed', 'Cancelled'],
  storeSearch: '',
  storeShowCategory: 'progress',
  storeShowBfixCategory: 'progress',
  storeSelectedStates: ['WA', 'NT', 'SA', 'QLD', 'NSW', 'TAS', 'VIC', 'ACT', 'NZ'].sort(),
  storeDrivers: [],
  storeJobsWithRequest4Change: [],
  isSideMenuOpen: false,
  isLoadingGlobal: false,
  error: undefined,
  errors: {
    networkError: '',
    loginError: null,
  },
  routerData: {
    prevUrl: {
      name: '',
      url: '',
    },
  },
};
